import { CALL_INTERNAL_API } from '../../middleware/authHeaders'
import { ACCEPT_JSON_HEADERS, INTERNAL_API_ROOT } from '../../config/api'
import {
  errorNotification,
  successNotification,
  warningNotification,
} from '../application/notifications'

// ACTIONS
export const POST_USERS_MERGE_REQUEST = 'POST_USERS_MERGE_REQUEST'
export const POST_USERS_MERGE_SUCCESS = 'POST_USERS_MERGE_SUCCESS'
export const POST_USERS_MERGE_FAILURE = 'POST_USERS_MERGE_FAILURE'
export const GET_USER_SEARCH_REQUEST = 'GET_USER_SEARCH_REQUEST'
export const GET_USER_SEARCH_SUCCESS = 'GET_USER_SEARCH_SUCCESS'
export const GET_USER_SEARCH_FAILURE = 'GET_USER_SEARCH_FAILURE'
export const SET_SEARCH_USER_TYPE = 'SET_SEARCH_USER_TYPE'
export const SET_SELECTED_USER = 'SET_SELECTED_USER'
export const CLEAR_FROM_USER_RESULTS = 'CLEAR_FROM_USER_RESULTS'
export const CLEAR_TO_USER_RESULTS = 'CLEAR_TO_USER_RESULTS'
export const SET_IS_POSTING = 'SET_IS_POSTING'

export const setSelectedUser =
  (user, isFromUser = true) =>
  dispatch => {
    const payload = isFromUser ? { selectedFromUser: user } : { selectedToUser: user }
    return dispatch({ type: SET_SELECTED_USER, payload })
  }

export const clearUserResults =
  (isFromUser = true) =>
  dispatch => {
    return isFromUser
      ? dispatch({ type: CLEAR_FROM_USER_RESULTS, payload: { fromUser: [] } })
      : dispatch({ type: CLEAR_TO_USER_RESULTS, payload: { toUser: [] } })
  }

export const mergeUserAccounts = (fromAccountUserId, toAccountUserId) => dispatch => {
  dispatch({ type: SET_IS_POSTING, payload: { isPosting: true } })
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'POST',
      endpoint: `${INTERNAL_API_ROOT}/admin/users/merge`,
      types: [POST_USERS_MERGE_REQUEST, POST_USERS_MERGE_SUCCESS, POST_USERS_MERGE_FAILURE],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
      body: JSON.stringify({ fromAccountUserId, toAccountUserId }),
    },
  }).then(response => {
    dispatch({ type: SET_IS_POSTING, payload: { isPosting: false } })
    if (response.error) {
      dispatch(
        errorNotification({
          header: `Error merging user accounts`,
          body: `unexpected error encountered, if it is persistent please file a ticket for engineering`,
          showIcon: true,
          dismissInSeconds: 5,
        })
      )
    } else {
      dispatch(
        successNotification({
          header: `Successfully merged user accounts`,
          body: `Some update side effects may take a few minutes to complete. Data should be fully migrated within 5 minutes`,
          showIcon: true,
          dismissInSeconds: 5,
        })
      )
      dispatch(setSelectedUser({}, true))
      dispatch(setSelectedUser({}, false))
    }
  })
}

export const getGMSUserSearchResults =
  (term, searchForFromUser = true) =>
  dispatch => {
    const searchUserType = searchForFromUser ? 'FROM' : 'TO'
    dispatch({ type: SET_SEARCH_USER_TYPE, payload: { searchUserType } })
    dispatch({
      [CALL_INTERNAL_API]: {
        method: 'GET',
        endpoint: `${INTERNAL_API_ROOT}/admin/users/search?search=${encodeURIComponent(term)}`,
        types: [GET_USER_SEARCH_REQUEST, GET_USER_SEARCH_SUCCESS, GET_USER_SEARCH_FAILURE],
      },
    }).then(response => {
      if (response.error) {
        dispatch(
          errorNotification({
            header: `Error searching for user`,
            body: `unexpected error encountered, if it is persistent please file a ticket for engineering`,
            showIcon: true,
            dismissInSeconds: 5,
          })
        )
      } else if (response?.payload.length === 0) {
        dispatch(
          warningNotification({
            header: `No results for ${term}`,
            body: `check the email address is correct and try again`,
            showIcon: true,
            dismissInSeconds: 5,
          })
        )
      }
    })
  }

export const selectMergeGMSUserAccounts = state => state.submittable.mergeGMSUserAccounts

// STATE
const INITIAL_STATE = {
  isPosting: false,
  searchResults: {
    fromUser: [],
    toUser: [],
  },
  searchUserType: 'FROM',
  selectedFromUser: {},
  selectedToUser: {},
}

// REDUCERS

const mergeGMSUserAccounts = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [SET_IS_POSTING]: (currentState, newPayload) => ({
      ...currentState,
      ...newPayload,
    }),
    [SET_SEARCH_USER_TYPE]: (currentState, newPayload) => ({
      ...currentState,
      ...newPayload,
    }),
    [SET_SELECTED_USER]: (currentState, newPayload) => ({
      ...currentState,
      ...newPayload,
    }),
    [CLEAR_FROM_USER_RESULTS]: currentState => ({
      ...currentState,
      searchResults: {
        ...currentState.searchResults,
        fromUser: [],
      },
    }),
    [CLEAR_TO_USER_RESULTS]: currentState => ({
      ...currentState,
      searchResults: {
        ...currentState.searchResults,
        toUser: [],
      },
    }),
    [GET_USER_SEARCH_SUCCESS]: (currentState, newPayload) => {
      if (currentState.searchUserType === 'FROM') {
        return {
          ...currentState,
          searchResults: {
            ...currentState.searchResults,
            fromUser: [...newPayload],
          },
        }
      }
      return {
        ...currentState,
        searchResults: {
          ...currentState.searchResults,
          toUser: [...newPayload],
        },
      }
    },
  }[type]?.(state, payload) || state)

export default mergeGMSUserAccounts
